import { render, staticRenderFns } from "./multiconnect.vue?vue&type=template&id=604604d6&scoped=true&"
import script from "./multiconnect.vue?vue&type=script&lang=js&"
export * from "./multiconnect.vue?vue&type=script&lang=js&"
import style0 from "./multiconnect.vue?vue&type=style&index=0&id=604604d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604604d6",
  null
  
)

export default component.exports